import events from "assets/images/picto-evenement.svg";
import accounting from "assets/images/compta-simplifiee.svg";
import timeSaving from "assets/images/gain-de-temps-picto.svg";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { OnePageSlider } from "reusableComponents";

import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useLanguage } from "context";
import { getPlaceOptions } from "services/homePage.services";

import SpaceCardStyled from "reusableComponents/SpaceCardStyled";

const AboutUsSection = () => {
  const [t] = useTranslation("global");
  const { language } = useLanguage();
  const navigate = useNavigate();

  const [zoomPlaces, setZoomPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeItem, setActiveItem] = useState(1); // Start with first item active (index 0)

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const [fetchedZoomPlaces] = await Promise.all([
        getPlaceOptions(language),
      ]);
      setZoomPlaces(fetchedZoomPlaces);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [language]);

  const renderZoomPlaces = () => {
    if (loading) return <div className={styles.loading}></div>;
    if (error) return <div className={styles.error}>{error}</div>;
    if (!zoomPlaces.length) return <div className={styles.empty}></div>;

    return zoomPlaces.map((place) => (
      <div className={styles.spaceCardContainer} key={place.uuid}>
        <SpaceCardStyled
          forHomePage
          key={place.uuid}
          place={place}
          showButton
          borderColor="primary"
          imageDisplay="single"
        />
      </div>
    ));
  };

  // Handle click on advantage item
  const handleItemClick = (itemIndex) => {
    setActiveItem(itemIndex);
  };

  return (
    <div className="smallContainer">
      <div className={styles.aboutUs}>
        <div className={styles.zoomPlaces}>
          <p className={styles.mainTitle}>{t("home.zoomOn")}</p>
          <OnePageSlider
            arrowLeft="16px"
            arrowRight="16px"
            arrowTop="35%"
            autoplay={true}
            infinite={renderZoomPlaces().length > 1 ? true : false}
            arrowStyle="square"
          >
            {" "}
            {renderZoomPlaces()}
          </OnePageSlider>
        </div>

        <div className={styles.advantages}>
          <h2
            className={styles.mainTitle}
            dangerouslySetInnerHTML={{ __html: t("home.siteDescription") }}
          ></h2>
          
          {/* Time Saving Item */}
          <div 
            className={`${styles.item} ${activeItem === 1 ? styles.active : ''}`}
            onClick={() => handleItemClick(1)}
          >
            <p
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: t("home.timeSaving") }}
            ></p>
            <p className={styles.description}>{t("home.timeSavingContent")}</p>
          </div>
          
          {/* Simplified Accounting Item */}
          <div 
            className={`${styles.item} ${activeItem === 2 ? styles.active : ''}`}
            onClick={() => handleItemClick(2)}
          >
            <p
              className={styles.title}
              dangerouslySetInnerHTML={{
                __html: t("home.simplifiedAccounting"),
              }}
            ></p>
            <p className={styles.description}>
              {t("home.simplifiedAccountingContent")}
            </p>
          </div>
          
          {/* Team of Experts Item */}
          <div 
            className={`${styles.item} ${activeItem === 3 ? styles.active : ''}`}
            onClick={() => handleItemClick(3)}
          >
            <p
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: t("home.teamOfExperts") }}
            ></p>
            <p className={styles.description}>
              {t("home.teamOfExpertsContent")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;